export { MONTHLY_TO_ANNUAL_CONTENT, CARD_BRAND_ICON_MAP, ACCEPTED_CARD_BRANDS } from '../../Upgrade/UpgradePowerMonthlyToAnnualPopup/constants';

export const DEFAULT_CURRENCY = 'USD';

export const SIDEBAR_CHECKOUT_CONTENT = {
    pricingMonthly: '/Month',
    renewalDateLabel: 'Renewal Date: ',
    ctaText: 'START POWER ANNUAL PLAN',
    disclaimer: {
        prefix: 'By tapping the button, I agree to the ',
        termsLink: 'Terms of Service',
        termsHref: '/terms',
        suffix: ' and automatic charges until I cancel.',
    },
    binCountryError: {
        title: 'Billing Country Does Not Match Your Residence',
        text: 'Our subscription pricing is based on your billing country. The rates have been updated accordingly.',
    },
    pastDueWarning: {
        boldPrefix: (renewalDate, cardBrand, last4) => `Your last renewal on ${renewalDate} with ${cardBrand} ending in ${last4}`,
        suffix: ' could not be processed due to a payment issue. Your Power benefits are on pause until payment is updated. Change your card below to upgrade to Power annual.',
    },
    pastDueAnnualCtaText: 'UPDATE PAYMENT DETAILS',
    pollingMessage: 'Verifying your payment...',
    pollExhaustedMessage: 'Your payment method has been updated. Your subscription may take a few moments to restore.',
    pollExhaustedRefresh: 'Refresh',
};

export const SUCCESS_SCENARIOS = {
    FREE_TO_ANNUAL: 'free_to_annual',
    MONTHLY_TO_ANNUAL: 'monthly_to_annual',
    PAST_DUE_ANNUAL: 'past_due_annual',
};

export const SUCCESS_CONTENT = {
    [SUCCESS_SCENARIOS.FREE_TO_ANNUAL]: {
        title: 'Welcome to Power!',
    },
    [SUCCESS_SCENARIOS.MONTHLY_TO_ANNUAL]: {
        title: 'Upgrade Successful!',
    },
    [SUCCESS_SCENARIOS.PAST_DUE_ANNUAL]: {
        title: 'Payment Updated!',
        message: (renewalDate) => `Your payment method has been updated and your Power annual plan is now active. Your plan will renew on ${renewalDate}.`,
    },
    message: (renewalDate) => `Your plan will renew annually on ${renewalDate}. Check your inbox for a confirmation email with all the details.`,
    ctaText: 'CONTINUE TO EVENT REGISTRATION',
};
